<!--机构概况-->
<template>
  <div class="institution">
    <!-- :style="$route.hash ? 'margin-top:40px' : ''" -->
    <div class="box box1">
      <div class="space-between mytab">
        <div class="tag">{{ details1.title }}</div>
      </div>
      <img
        :alt="details1.title"
        :src="path + details1.thumbnail"
        class="box-img"
        align="right"
      />
      <div class="content" v-html="details1.content"></div>
    </div>
    <institution-tab class="pc-comp"></institution-tab>
    <mobile-institution-tab class="mobile-comp"></mobile-institution-tab>
    <!--桂林分中心-->
    <div class="box box2">
      <div class="introduction-one">
        <div class="space-between mytab title2">
          <div class="tag" style="width: 320px;">{{ details2.title }}</div>
        </div>
        <img
          :alt="details2.title"
          :src="path + details2.thumbnail"
          class="img2"
          align="left"
        />
        <div class="content" v-html="details2.content"></div>
      </div>
    </div>
    <div class="pc-comp">
      <div class="map" @click="tomap"></div>
      <div class="info flex">
        <div @click="tomap" class="flex pointer">
          <img src="../../assets/images/info_icon0.webp" alt="" />
          <p>
            <b>详细地址</b>
            <span> 桂林市临桂区人民南路桂林医疗器械创新创业孵化基地(一期)5号楼</span>
          </p>
        </div>
      </div>
    </div>
    <!--桂林分中心的移动端-->
    <div class="mobile-comp">
      <div class="map-info">
        <b>详细地址</b>
        <span>桂林市临桂区人民南路桂林医疗器械创新创业孵化基地(一期)5号楼</span>
        <div class="map" @click="tomap"></div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { getArticleDetails } from '@/api/index'
import institutionTab from '../../components/institutional/institution-tab.vue'
import mobileInstitutionTab from '../../components/institutional/mobile-institution-tab.vue'
export default {
  name: 'institutionalOverview',
  components: {
    institutionTab,
    mobileInstitutionTab
  },
  data() {
    return { details1: {}, details2: {}, path: process.env.VUE_APP_BASE_API }
  },
  methods: {
    getIndexData() {},
    tomap() {
      window.open(
        'https://map.baidu.com/poi/%E5%B9%BF%E8%A5%BF%E5%8C%BB%E7%96%97%E5%99%A8%E6%A2%B0%E6%A3%80%E6%B5%8B%E4%B8%AD%E5%BF%83%E6%A1%82%E6%9E%97%E5%88%86%E4%B8%AD%E5%BF%83/@12265183.239196578,2883128.8665230935,12.87z,360h?uid=5c5ec8efb80cf065eaf85375&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl',
        '_blank'
      )
    },
  },
  mounted() {
    // 获取两个内容的数据
    getArticleDetails(521)
      .then((res) => {
        this.details1 = res
      })
      .finally(() => {})
    getArticleDetails(522)
      .then((res) => {
        this.details2 = res
      })
      .finally(() => {})
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.institution {
  .box {
    position: relative;
    min-height: 321px;
    }
    .mytab {
      width: 572px;
      height: 50px;
      position: absolute;
    }
    img {
      width: 590px;
      height: 321px;
      margin-left: 36px;
    }
    .content {
      padding-top: 66px;
    }
  }
  .map {
    width: 100%;
    height: 298px;
    background: url(../../assets/images/img_map_1.webp) no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .info {
    background: #f8f8f8;
    height: 144px;
    width: 100%;
    .flex {
      padding: 32px 0 0 32px;
      img {
        width: 80px;
        height: 80px;
      }
      p {
        margin-bottom: 0;
        margin-left: 32px;
        b {
          display: block;
          color: #1b6ad2;
          margin-bottom: 4px;
          font-size: 18px;
        }
        span {
          font-family: Microsoft YaHei, Microsoft YaHei;
          display: block;
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          line-height: 26px;
        }
      }
    }
  }
.box1 {
  margin-bottom: 32px;
}
.box2 {
  // margin-bottom: 40px;
  .mytab {
    width: 680px;
    right: 0;
    justify-content: flex-end;
    .tag {
      background: url(../../assets/images/tab_selecte_1.png) no-repeat;
      background-size: 100% 100%;
      padding-left: 46px;
    }
  }
  img {
    width: 482px;
    height: 236px;
    margin-left: 0px;
    margin-right: 36px;
  }
}
@media screen and (max-width: 768px) {
  .institution {
    padding: 0;
    margin: 0;
    .box {
      min-height: 321px;

      .mytab {
        width: 100%;
        position: static;
      }
      img {
        width: 100%;
        height: 240px;
        margin-left: 36px;
      }
      .content {
        padding-top: 66px;
      }
    }
    .box1 {
      margin-bottom: 32px;
    }
    .box2 {
      .mytab {
        justify-content: start;
        .tag {
          background: url(../../assets/images/tab_selecte.webp) no-repeat;
          background-size: 100% 100%;
          padding-left: 46px;
        }
      }
      .mytab.title2 .tag {
        width: 300px !important;
      }
      img {
        margin-left: 0px;
        margin-right: 36px;
      }
    }
    .map-info {
      b {
        display: block;
        color: #1b6ad2;
        margin-top: 16px;
      }
      span {
        display: block;
      }
      .map {
        width: 100%;
        height: 200px;
        background: url(../../assets/images/img_map_1.webp) no-repeat;
        background-size: 100% 100%;
        margin-top: 16px;
        margin-bottom: 40px;
      }
    }
  }
}
</style>
